"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaysDiff = void 0;
var moment_1 = __importDefault(require("moment"));
/**
 *
 * @param {*} inputDate format : YYYY MM DD
 * @param {*} dateToCompare format : YYYY MM DD (optional)
 * @returns
 */
var getDaysDiff = function (inputDate, dateToCompare) {
    if (dateToCompare === void 0) { dateToCompare = null; }
    var now = dateToCompare ? (0, moment_1.default)(dateToCompare) : (0, moment_1.default)();
    var inputMoment = (0, moment_1.default)(inputDate);
    var daysDiff = now.diff(inputMoment, 'days', true);
    return { count: daysDiff, dateIsPassed: daysDiff > 0 ? true : false };
};
exports.getDaysDiff = getDaysDiff;
